import {Dispatch, SetStateAction} from 'react'

export type ID = undefined | null | number

export type PaginationState = {
  page: number
  // items_per_page: 10 | 30 | 50 | 100
  items_per_page: number
  // links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
}

export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
}

export type FilterState = {
  filter?: unknown
}

export type SearchState = {
  search?: string
}

export type FilterStartDate = {
  start_date?: string
}
export type FilterEndDate = {
  end_date?: string
}
export type FilterDate = {
  date?: string
}
export type FilterUser = {
  user?: string
}
export type FilterDestinationCountry = {
  destination_country?: string
}

export type FilterCity = {
  city_id?: number
}

export type FilterCategory = {
  category?: string
}

export type FilterTransferType = {
  transfer_type?: string
}

export type FilterAgentFields = {
  agent_country?: string
  agent_city?: string
  agent_category?: string
  agent_type?: string
}

export type FilterAssignment = {
  assign_to?: string
  is_accepted?: string
}

export type Response<T> = {
  data?: {
    [key: string]: T
  }
  message?: string
  errors?: {
    [key: string]: Array<string>
  }
  pagination?: PaginationState
}

export type QueryState = PaginationState &
  SortState &
  FilterState &
  SearchState &
  FilterStartDate &
  FilterEndDate &
  FilterDate &
  FilterUser &
  FilterDestinationCountry &
  FilterCity &
  FilterCategory &
  FilterTransferType &
  FilterAgentFields &
  FilterAssignment

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

export const initialQueryState: QueryState = {
  page: 1,
  items_per_page: 10,
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined
  refetch: () => void
  isLoading: boolean
  query: string
}

export const initialQueryResponse = {
  refetch: () => {},
  isLoading: false,
  query: '',
}

export type ListViewContextProps = {
  selected: Array<ID>
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void
  // NULL => (CREATION MODE) | MODAL IS OPENED
  // NUMBER => (EDIT MODE) | MODAL IS OPENED
  // UNDEFINED => MODAL IS CLOSED
  itemIdForUpdate?: ID
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>
  isAllSelected: boolean
  disabled: boolean
}

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  isAllSelected: false,
  disabled: false,
}
